/**
 * Slider recensioni (sections/reviews-slider.liquid).
 * Scorrimento con scroll-snap; frecce su desktop, swipe su mobile.
 * Autoplay solo quando lo slider è visibile, in pausa su hover/focus/touch
 * e disattivato con "riduci movimento".
 */
class ReviewsSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.prevButton = this.querySelector('[data-prev]');
    this.nextButton = this.querySelector('[data-next]');
    if (!this.track) return;

    this.paused = false;
    this.visible = false;
    this.delay = Number(this.dataset.delay) || 5000;

    this.prevButton?.addEventListener('click', () => this.step(-1));
    this.nextButton?.addEventListener('click', () => this.step(1));
    this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });

    for (const type of ['pointerenter', 'focusin', 'touchstart']) {
      this.addEventListener(type, () => (this.paused = true), { passive: true });
    }
    for (const type of ['pointerleave', 'focusout']) {
      this.addEventListener(type, () => (this.paused = false));
    }

    this.updateButtons();

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (this.dataset.autoplay !== 'true' || reducedMotion) return;

    this.observer = new IntersectionObserver(([entry]) => (this.visible = entry?.isIntersecting ?? false));
    this.observer.observe(this);
    this.timer = setInterval(() => this.autoplay(), this.delay);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
    this.observer?.disconnect();
  }

  get cardWidth() {
    const card = this.track.firstElementChild;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    return card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
  }

  get atEnd() {
    return this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
  }

  step(direction) {
    this.track.scrollBy({ left: direction * this.cardWidth });
  }

  autoplay() {
    if (this.paused || !this.visible || document.hidden) return;
    if (this.atEnd) {
      this.track.scrollTo({ left: 0 });
    } else {
      this.step(1);
    }
  }

  updateButtons() {
    if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 2;
    if (this.nextButton) this.nextButton.disabled = this.atEnd;
  }
}

if (!customElements.get('reviews-slider')) {
  customElements.define('reviews-slider', ReviewsSlider);
}
